import React from "react";

const features = [
  {
    title: "Secure Banking",
    desc: "Your privacy is our priority. We use top security measures to protect your data.",
    icon: "🤝",
    color: "text-orange-500",
  },
  // {
  //   title: "Fast Access",
  //   desc: "Check balances, transfer funds, and manage your finances with just a few taps.",
  //   icon: "🏦",
  //   color: "text-yellow-500",
  // },
  {
    title: "Reliable Support",
    desc: "We're here for you anytime with dependable support whenever you need it.",
    icon: "🌐",
    color: "text-cyan-500",
  },
  {
    title: "Easy to Use",
    desc: "Enjoy an intuitive and smooth experience as you navigate through your account.",
    icon: "💰",
    color: "text-indigo-500",
  },
];

export default function WhyChooseUs() {
  return (
 <section className="relative bg-white -mt-28 md:mt-0 pt-20 md:pt-32 pb-16 md:pb-24">

      {/* FLOATING CARD */}
      <div
        className="
    relative
    md:absolute md:-top-24
    w-[90%] max-w-6xl
    mx-auto
    md:left-1/2 md:-translate-x-1/2
  "
      >

        <div className="backdrop-blur-xl bg-white/80 rounded-3xl shadow-2xl border border-white/40">
          <div className="grid md:grid-cols-3 divide-y md:divide-y-0 md:divide-x">
            {features.map((f) => (
              <div
                key={f.title}
                className="p-8 text-center hover:bg-white/60 transition duration-300 group"
              >
                <div
                  className={`text-4xl mb-4 ${f.color} group-hover:scale-110 transition`}
                >
                  {f.icon}
                </div>
                <h3 className="text-lg font-semibold mb-2">
                  {f.title}
                </h3>
                <p className="text-sm text-gray-600">
                  {f.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

